export interface NachrichtenThreadSummary {
  threadId: string;
  unread: boolean;
}

export function unreadThreadIdSet(threads: NachrichtenThreadSummary[]): Set<string> {
  return new Set(threads.filter((t) => t.unread).map((t) => t.threadId));
}
